import { useEffect, useState } from "react";

const KEY = "bp_data_saver";
let saver = false;
try { saver = localStorage.getItem(KEY) === "1"; } catch (e) { console.debug("localStorage unavailable", e?.message); }
const subs = new Set();

export const isDataSaver = () => saver;

export const setDataSaver = (v) => {
  saver = !!v;
  try { localStorage.setItem(KEY, saver ? "1" : "0"); } catch (e) { console.debug("localStorage unavailable", e?.message); }
  subs.forEach((f) => f(saver));
};

export const pollMs = (base) => (saver ? base * 3 : base);

export function useDataSaver() {
  const [v, setV] = useState(saver);
  useEffect(() => {
    subs.add(setV);
    return () => subs.delete(setV);
  }, []);
  return v;
}
